import React from 'react';
import './Loader.scss';

const Loader = ({ lightMode = false }) => (
  <div className={`c-loader ${lightMode ? 'light-mode' : ''}`}></div>
);

export default Loader;
